import { useMaskito } from "@maskito/react";

export const useDUIMask = () => {
  return useMaskito({
    options: {
      mask: [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, "-", /\d/],
    },
  });
};

export const useNITMask = () => {
  return useMaskito({
    options: {
      mask: [
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        "-",
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        "-",
        /\d/,
        /\d/,
        /\d/,
        "-",
        /\d/,
      ],
    },
  });
};

export const usePhoneMask = () => {
  return useMaskito({
    options: {
      mask: [/\d/, /\d/, /\d/, /\d/, " ", /\d/, /\d/, /\d/, /\d/],
    },
  });
};
